"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLargerThan = exports.estimateSize = void 0;
/**
 * Estimate the size of the given object in bytes.
 * @param obj Object to estimate the size of.
 */
var estimateSize = function (obj) {
    return estimateSizeUpToMax(obj, Number.POSITIVE_INFINITY);
};
exports.estimateSize = estimateSize;
/**
 * Estimate whether the size of the given object is larger than the given number of bytes.
 * @param obj Object to estimate the size of.
 * @param bytes The threshold to compare the object size estimate to.
 */
var isLargerThan = function (obj, bytes) {
    return estimateSizeUpToMax(obj, bytes) > bytes;
};
exports.isLargerThan = isLargerThan;
/**
 * Estimate the size of the given object in bytes. Stop after exceeding maxBytes.
 * @param obj Object to estimate the size of.
 * @param maxBytes The threshold at which to stop estimating the size of the object.
 */
var estimateSizeUpToMax = function (obj, maxBytes) {
    var bytes = 0;
    var visited = [];
    var stack = [obj];
    while (stack.length > 0) {
        var value = stack.pop();
        var valueType = typeof value;
        if (valueType === 'boolean') {
            bytes += 4;
        }
        else if (valueType === 'string') {
            bytes += 2 * value.length;
        }
        else if (valueType === 'number') {
            bytes += 8;
        }
        else if (valueType === 'object' && value && visited.indexOf(value) === -1) {
            if (value instanceof Uint8Array) {
                bytes += value.length;
            }
            else {
                visited.push(value);
                // NOTE: We use for...in since Object.keys() is only a subset of serializable properties
                for (var key in value) {
                    stack.push(value[key]);
                }
            }
        }
        // Return a partial size estimate if maxBytes is exceeded
        if (bytes > maxBytes) {
            return bytes;
        }
    }
    return bytes;
};
//# sourceMappingURL=estimate-size.js.map